import getNotificationApi from 'common/lib/api/notification';
import api from 'lib/api';
import type { Dispatch, GetState } from 'state/types';

export const markNotificationAsOpened = (id: string) => async (dispatch: Dispatch, _: GetState) => {
  await getNotificationApi(api).updateSentNotification({ id, opened: true });
};
